import React from 'react';
import type { ReviewDocument } from './types';
interface HoverPreviewProps {
  hoveredDoc: ReviewDocument | null;
  hoverPosition: {
    top: number;
    left: number;
  } | null;
  selectedDocId: string | null;
}
export function HoverPreview({
  hoveredDoc,
  hoverPosition,
  selectedDocId
}: HoverPreviewProps) {
  if (!hoveredDoc || !hoverPosition || hoveredDoc.id === selectedDocId) {
    return null;
  }
  return <div className="fixed z-[60] max-w-sm pointer-events-none animate-in fade-in duration-150" style={{
    top: hoverPosition.top,
    left: hoverPosition.left,
    transform: 'translate(-50%, -100%)'
  }} data-id="element-422" data-mp="2602n90bxvkls">
      <div className="bg-[#0A1520] border border-navy-lighter rounded-lg shadow-2xl px-4 py-3 space-y-1.5" data-id="element-423" data-mp="1w5ase49qrbup">
        <div className="flex items-center gap-2" data-id="element-424" data-mp="3qgxwyiifqqoa">
          <span className="font-mono text-[10px] text-gray-500" data-id="element-425" data-mp="3qi914jfsm0fx">
            {hoveredDoc.id}
          </span>
          <span className="text-gray-600" data-id="element-426" data-mp="3vfim9mw5fpxy">·</span>
          <span className="text-xs text-gray-400" data-id="element-427" data-mp="38vielzwen0fu">{hoveredDoc.date}</span>
        </div>
        <div className="text-sm text-white font-medium leading-snug" data-id="element-428" data-mp="33woys0tnaxci">
          {hoveredDoc.subject}
        </div>
        <p className="text-xs text-gray-400 leading-relaxed" data-id="element-429" data-mp="3ilbl4mhowpd8">
          {hoveredDoc.mediumSummary || hoveredDoc.summary}
        </p>
      </div>
    </div>;
}